module.exports = __webpack_public_path__ + "img/donante-ibero.6ff253c3.png";